// PARAQTA — Дауыс категориялары (жетістіктер тізімі backend-ке көшті, 04.10.26).

// 04.10.26: ескі 16-лық ACHIEVEMENTS тізімі АЛЫНДЫ — жетістіктердің жалғыз
// дереккөзі backend (main.py ACHIEVEMENT_DEFS → /api/profile/me achievements).


export const DAWYS_CAT     = { review: 'Рецензия', reflection: 'Рефлексия', essay: 'Эссе' };
export const DAWYS_CAT_CLS = { review: 'review',  reflection: 'reflection', essay: 'essay' };
